import { c as _c } from "react/compiler-runtime";
import { Button, HStack, Text } from '@chakra-ui/react';
import React from 'react';

/**
 * The pager under a list that loads in pages. It says how many are shown out of how many the server
 * has, so a count above it never claims more than is loaded. Renders nothing on the last page.
 */
export function CrmLoadMore(props) {
  const $ = _c(10);
  if (!props.hasMore) {
    return null;
  }
  const t0 = props.unit ? ` ${props.unit}` : "";
  let t1;
  if ($[0] !== props.loaded || $[1] !== props.total || $[2] !== t0) {
    t1 = <Text color="fg.subtle" fontSize="xs">Showing {props.loaded} of {props.total}{t0}</Text>;
    $[0] = props.loaded;
    $[1] = props.total;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.loading || $[5] !== props.onLoadMore) {
    t2 = <Button disabled={props.loading} loading={props.loading} size="xs" variant="outline" onClick={props.onLoadMore}>Load more</Button>;
    $[4] = props.loading;
    $[5] = props.onLoadMore;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <HStack gap={3} justify="center" px={4} py={3}>{t1}{t2}</HStack>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}